import { render, staticRenderFns } from "./LayoutShape.vue?vue&type=template&id=b9395026&"
import script from "./LayoutShape.vue?vue&type=script&lang=js&"
export * from "./LayoutShape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports